import { Table as MuiTable, TableProps as MuiTableProps } from "@mui/material";
import { forwardRef } from "react";

type TableProps = MuiTableProps & {};

export const Table = forwardRef<HTMLTableElement, TableProps>(({ children, ...rest }, ref) => {
  return (
    <MuiTable ref={ref} {...rest}>
      {children}
    </MuiTable>
  );
});
